const isoDatePattern = 'yyyy-MM-dd';
const isoDatePatternForFilename = 'yyyyMMdd';
const isoDatePatternWithSlashes = 'yyyy/MM/dd';
const frenchDatePattern = 'dd-MM-yyyy';
const frenchDatePatternWithSlashes = 'dd/MM/yyyy';
const enDatePatternWithSlashes = 'MM/dd/yyyy';
const frenchDatePatternShort = 'dd/MM/yy';
const enDatePatternShort = 'MM/dd/yy';
// TODO use localized time format to support AM/PM?
const frenchDatePatternWithSlashesAndHours = 'dd/MM/yyyy HH:mm';

export {
  frenchDatePattern,
  frenchDatePatternShort,
  enDatePatternShort,
  frenchDatePatternWithSlashes,
  enDatePatternWithSlashes,
  frenchDatePatternWithSlashesAndHours,
  isoDatePattern,
  isoDatePatternForFilename,
  isoDatePatternWithSlashes,
};
